import React from 'react';
import styled from 'styled-components';
import PText from '../components/PText';
//import Button from '../components/Button';
import AboutImg from '../assets/images/about-page-img.png';
import AboutInfoItem from '../components/AboutInfoItem';
import ContactBanner from '../components/ContactBanner';

const AboutPageStyles = styled.div`
  padding: 20rem 0 10rem 0;
  .top-section {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
  }
  .left {
    flex: 3;
  }
  .right {
    flex: 2;
  }
  .about__subheading {
    font-size: 2.2rem;
    margin-bottom: 2rem;
    span {
      background-color: var(--deep-dark);
      padding: 0.5rem;
      border-radius: 8px;
    }
  }
  .about__heading {
    font-size: 3.6rem;
    margin-bottom: 3rem;
  }
  .about__info {
    margin-bottom: 4rem;
    .para {
      max-width: 100%;
    }
  }
  .right {
    img {
      border: 2px solid var(--gray-1);
    }
  }
  .about__info__items {
    margin-top: 15rem;
  }
  .about__info__item {
    margin-bottom: 10rem;
  }
  .about__info__item:last-child {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1.6rem;
    margin-top: 3rem;
    .about__info__heading { grid-column: 1 / -1; margin-bottom: .5rem; }
    & > div { margin: 0; }
  }
  .about__info__heading {
    font-size: 3.6rem;
    text-transform: uppercase;

  }
  margin-top: 2rem;
  .button {
    cursor:pointer;
    font-size: 2.2rem;
    background-color: ${(props) =>
    props.outline ? 'transperant' : 'var(--gray-1)'};
    padding: 0.7em 2em;
    border: 2px solid var(--gray-1);
    border-radius: 8px;
    display: inline-block;
    color: ${(props) => (props.outline ? 'var(--gary-1)' : 'black')};
  }
  @media only screen and (max-width: 768px) {
    .button {
      font-size: 1.8rem;
    }
  }
  @media only screen and (max-width: 768px) {
    padding: 10rem 0;
    .top-section {
      flex-direction: column;
      gap: 5rem;
    }
    .about__subheading {
      font-size: 1.8rem;
    }
    .about__heading {
      font-size: 2.8rem;
    }
    .about__info__heading {
      font-size: 3rem;
    }
    .about__info__item:last-child { grid-template-columns: 1fr; .about__info__heading { grid-column: auto; } }
  }
`;

export default function About() {
  return (
    <>
      <AboutPageStyles>
        <div className="container">
          <div className="top-section">
            <div className="left">
              <p className="about__subheading">
                Hi, I am <span>Ajith</span>
              </p>
              <h2 className="about__heading">Full Stack Engineer building dependable products.</h2>
              <div className="about__info">
                <PText>
                  I’m Ajith D, a Full Stack Engineer from Coimbatore with 4+ years of experience delivering web applications, APIs, AI-enabled workflows, and mobile products.
                  <br /> <br />
                  I work across React, TypeScript, Node.js, Express, Python FastAPI, SQL Server, React Native, and Microsoft Azure. I care about clean interfaces, reliable backend systems, and measurable performance.
                  <br />
                  <br />
                  Recently, I helped optimize a course-record API from about 3 seconds to 200 milliseconds and shipped features across recruitment automation and online learning products.
                </PText>
              </div>
              <button className="button" outline='false' 
              onClick={(e) => {
                e.preventDefault();
                window.open('https://drive.google.com/drive/folders/17BFbjXjhMXZaoqEompZZM_HD62Tu46tn?usp=sharing', "_blank")
                // window.location.href = 'https://drive.google.com/drive/folders/17BFbjXjhMXZaoqEompZZM_HD62Tu46tn?usp=sharing';
              }} >Download CV</button>
              {/* onClick={(e) => {window.open("https://drive.google.com/u/1/uc?id=<fileId>&export=download", "_blank");}} */}
            </div>
            <div className="right">
              <img src={AboutImg} alt="me" />
            </div>
          </div>
          <div className="about__info__items">
            <div className="about__info__item">
              <h1 className="about__info__heading">Education</h1>

              <AboutInfoItem
                title="Scaler"
                items={['Software Development with AI Specialization · 2024–2026']}
              />
              <AboutInfoItem
                title="Diploma"
                items={['Diploma in Automobile Engineering · Nachimuthu Polytechnic College · 2015–2018']}
              />

            </div>
            <div className="about__info__item">
              <h1 className="about__info__heading">My Skills</h1>

              <AboutInfoItem
                title="Frontend & Mobile"
                items={['React.js', 'Next.js', 'TypeScript', 'React Native', 'HTML5', 'CSS3', 'Tailwind CSS', 'SCSS']}
              />
              <AboutInfoItem
                title="Backend & Data"
                items={['Node.js', 'Express.js', 'Python FastAPI', 'REST APIs', 'SQL Server', 'Azure SQL', 'MySQL', 'PostgreSQL', 'Sequelize']}
              />
              <AboutInfoItem
                title="Cloud & Delivery"
                items={['Azure VMs', 'Azure Blob Storage', 'Nginx', 'PM2', 'Linux', 'DNS', 'SSL/TLS']}
              />
              <AboutInfoItem
                title="Integrations"
                items={['Stripe Payments', 'Webhooks', 'Email Notifications', 'Third-party APIs', 'Authentication', 'RBAC']}
              />
              <AboutInfoItem
                title="Tools & Practices"
                items={['Git', 'GitHub', 'Postman', 'API Integration', 'Input Validation', 'Error Handling']}
              />
              <AboutInfoItem
                title="Architecture"
                items={['Authentication', 'Role-Based Access', 'Background Jobs', 'Microservices', 'Production Support']}
              />
            </div>
          </div>
        </div>
        <ContactBanner />
      </AboutPageStyles>
    </>
  );
}
